'use client';

import { emphasisOptions } from "./constants.js";
const validateEmphasis = (emphasis) => {
  if (emphasisOptions.find((i) => i === emphasis)) {
    return emphasis;
  }
  return void 0;
};
export {
  validateEmphasis
};
